import React, { useEffect, useRef, useState } from 'react';
import { Url } from '../../../../../common/constants/environment';
import clsx from 'clsx';
import useModalStore from '../../../../../hooks/useModalStore';
import useCheckLogin from '../../../../../hooks/useCheckLogin';
import { useHistory } from 'react-router-dom';
import useUsersStore from '../../../../../hooks/useUsersStore';
import { ScoreDetailService } from '../../../../../common/services';
import styled, { css } from 'styled-components';
import CheckBoxIcon from 'images/common-function/check-box.svg';

const MatchCheerCommentInput = ({
  postCheerComment,
  toggleSmallView,
  setViewChatInput
}) => {
  const { isCheckLogin } = useCheckLogin();
  const inputRef = useRef();
  const modal = useModalStore();
  const userStore = useUsersStore();
  const history = useHistory();

  const [text, setText] = useState('');
  const [uploadImage, setUploadImage] = useState(null);
  const [imgUrl, setImgUrl] = useState('');
  const [isCasterChat, setCasterChat] = useState(false);

  const onChangeText = (e) => {
    setText(e.target.value);
  };

  const onClickSubmit = () => {
    if (text.length === 0) {
      alert('메세지를 입력하세요.');
      return;
    }

    if (!isCheckLogin) {
      modal.openConfirmModal({
        message: '로그인 후 사용이 가능 합니다. 로그인 하시겠습니까?',
        okCallback: () => history.push('/auth/login')
      });
      return;
    }

    if (!userStore.data.is_admin) {
      if (!userStore.data.certify.is_phone_certify) {
        modal.openConfirmModal({
          message: '휴대폰 인증 후 사용이 가능 합니다. 인증 하시겠습니까?',
          okCallback: () => history.push('/mypage/info')
        });
        return;
      }
    }

    if (window.sessionStorage.getItem('lastMessage') === text) {
      alert('반복된 메세지는 입력할 수 없습니다.');
      return;
    }

    let param = {
      content: text,
      device: 'WEB_MOBILE',
      homeAway: null,
      selectTeamId: null
    };

    if (uploadImage) {
      param.imagePath = imgUrl;
    }

    if (isCasterChat) {
      param.casterType = 'caster';
      param.messageType = 'caster';
    }

    postCheerComment(param).then((res) => {
      if (res.status === 200) {
        setText('');
        toggleSmallView(false);
        setUploadImage(null);
        setImgUrl('');
        window.sessionStorage.setItem('lastMessage', text);
      } else {
        modal.openAlertModal({
          message: res.data.message
        });
      }
    });
  };

  const onInputFocus = () => {
    toggleSmallView(true);
  };

  const onInputBlur = () => {
    toggleSmallView(false);
  };

  const onInputKeyDown = (e) => {
    if (e.keyCode === 13) {
      onClickSubmit();
    }
  };

  const onClickImageCancel = () => {
    setUploadImage(null);
    setImgUrl('');
  };

  useEffect(() => {
    const maxSize = 1024 * 1024 * 20; // 20MB
    if (!!uploadImage) {
      if (uploadImage.size > maxSize) {
        alert('업로드 가능한 용량을 초과하였습니다. (20MB)');
        return;
      }
      ScoreDetailService.cheerImageChange(uploadImage).then((response) => {
        const { code, data } = response;
        if (code === 200) {
          setImgUrl(data.image_path);
        } else {
          alert(response.message);
        }
      });
    }

    return () => {
      setImgUrl('');
    };
  }, [uploadImage]);

  return (
    <div className="cheer_input_area" ref={inputRef}>
      <div className="inner">
        <label className={'img_upload'}>
          <input
            type={'file'}
            multiple={true}
            accept="image/*"
            onChange={(e) => {
              setUploadImage(e.target.files[0]);
            }}
          />
        </label>

        <input
          type="text"
          className="cheer_input_box"
          placeholder="응원 메시지를 입력해주세요."
          value={text}
          onChange={onChangeText}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          onKeyDown={onInputKeyDown}
        />
        {userStore.data.mb_id.includes('caster_account') && (
          <CheckBoxLabel>
            <input
              type={'checkbox'}
              onChange={(event) => setCasterChat(event.target.checked)}
            />
            <i />
          </CheckBoxLabel>
        )}
        {text.length > 0 ? (
          <button
            type="submit"
            className={clsx('btn', 'btn_enter', text.length > 0 && 'on')}
            onClick={onClickSubmit}
          >
            메시지 입력
          </button>
        ) : (
          <button
            className={clsx('btn', 'btn_power')}
            onClick={() => {
              setViewChatInput(true);
              toggleSmallView(true);
            }}
          >
            파워챗
          </button>
        )}
        <UploadImageWrap isActive={imgUrl !== ''}>
          {imgUrl && (
            <>
              <PreviewImage
                imageUrl={`${Url.thumb}normal/resize/100x100${imgUrl}`}
              />
              <PreviewImageCancel onClick={onClickImageCancel} />
              <PreviewLoading />
            </>
          )}
        </UploadImageWrap>
      </div>
    </div>
  );
};

const UploadImageWrap = styled.div`
  position: absolute;
  bottom: 53px;
  left: 5px;
  background-color: #f5f5f5;
  border-radius: 5px;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  transition: opacity 0.2s ease, transform 0.2s ease;
  will-change: opacity, transform;
  ${(props) =>
    props.isActive
      ? css`
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          opacity: 0;
          transform: translateY(10px);
          visibility: hidden;
        `}
`;

const PreviewImage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 5px;
  background: url(${(props) => props.imageUrl}) no-repeat center center;
  background-size: contain;
  z-index: 1;
`;

const PreviewImageCancel = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 22px;
  height: 22px;
  background: url('/images/ic-delete-pic.svg') no-repeat center center;
  background-size: 22px 22px;
  z-index: 2;
`;

const PreviewLoading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 8px;
  margin: -4px 0 0 -16px;
  background: url('/images/loading.svg') no-repeat 0 0;
  background-size: 36px 8px;
  color: transparent;
`;

const CheckBoxLabel = styled.label`
  position: absolute;
  right: 52px;
  top: 15px;
  > input {
    width: 0;
    height: 0;
    border: 0;
    margin: 0;
    & + i {
      display: inline-block;
      width: 18px;
      height: 18px;
      border: 1px solid #e5e5e5;
      border-radius: 50%;
    }
    &:checked + i {
      background: url(${CheckBoxIcon}) no-repeat center center;
    }
  }
`;

export default MatchCheerCommentInput;
